import * as turf from "@turf/turf";
import { Coord, Feature, LineString, Position, Units } from "@turf/turf";
import { Feature as GeoFeature } from "geojson";
import { FEATURE, FeatureGeometry, FeatureProps } from "../../core/geo/types";
import GeometryType from "ol/geom/GeometryType";

export const lineArc = (
    center: Coord,
    radius: number,
    bearing1: number,
    bearing2: number,
    options?: {
        steps?: number;
        units?: Units;
    }
) => turf.lineArc(center, radius, bearing1, bearing2, options);

export const distance = (
    from: Coord,
    to: number[],
    options?: {
        units?: Units;
    }
) => turf.distance(from, turf.point(to), options);

export const bearing = (
    start: Coord,
    end: number[],
    options?: {
        final?: boolean;
    }
) => turf.bearing(start, turf.point(end), options);

export const along = (
    startPoint: number[],
    endPoint: number[],
    distance: number,
    options?: {
        units?: Units;
    }
) => turf.along(turf.lineString([startPoint, endPoint]), distance, options);

export const destination = (origin: Coord, distance: number, bearing: number) =>
    turf.destination(origin, distance, bearing);

export const lineBuffer = (coordinates: number[][], radius?: number) => {
    const geoJsonFeature: GeoFeature<FeatureGeometry, FeatureProps> = {
        type: FEATURE,
        geometry: {
            type: GeometryType.LINE_STRING,
            coordinates: coordinates,
        },
        properties: {
            id: "buffer",
        },
    };
    return turf.buffer(geoJsonFeature, radius, { units: "nauticalmiles" });
};

export const booleanClockwise = (param: Feature<LineString> | LineString | Position[]) => {
    return turf.booleanClockwise(param);
};
